import { MessageStyled, MessageVariant } from './Message.styles';

interface Props {
  variant: MessageVariant;
  text?: string | null;
  deleted?: boolean;
  translated?: boolean;
  'data-testid'?: string;
}
export const Message = ({ ...props }: Props) => (
  <MessageStyled {...props}>{props.text}</MessageStyled>
);
